import React from "react";
import GenericForm from "./GenericForm";
import ColorInput from "../formElements/ColorInput";
import CodeMirror from '@uiw/react-codemirror';
import CssCodeInput from "../formElements/CssCodeInput";
import FourColumnRows from "../formElements/FourColumnRows";
import RichTextInput from "../formElements/RichTextInput";
import StringInput from "../formElements/StringInput";
import MultilineStringInput from "../formElements/MultilineStringInput";

function CompanySetupForm(props) {
    const formContent = (data, update) => (
        <>
            <FourColumnRows>
                <ColorInput name={'Config.Colors.ColorA'} label={'Farba A'} value={data.Config.Colors.ColorA} onChange={update}/>
                <ColorInput name={'Config.Colors.ColorB'} label={'Farba B'} value={data.Config.Colors.ColorB} onChange={update}/>
                <ColorInput name={'Config.Colors.ColorC'} label={'Farba C'} value={data.Config.Colors.ColorC} onChange={update}/>
                <ColorInput name={'Config.Colors.ColorD'} label={'Farba D'} value={data.Config.Colors.ColorD} onChange={update}/>
            </FourColumnRows>
            <CssCodeInput name={'CustomerCss'} label={'Report Css'} value={data.CustomerCss} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.serviceCase.caseText'} label={'SP formulka'} value={data.ReportConfig.serviceCase.caseText} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.serviceCase.priceText'} label={'SP/CP formulka'} value={data.ReportConfig.serviceCase.priceText} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.btk.caseText'} label={'BTK formulka'} value={data.ReportConfig.btk.caseText} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.btk.priceText'} label={'BTK/CP formulka'} value={data.ReportConfig.btk.priceText} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.loan.caseText'} label={'ZP formulka'} value={data.ReportConfig.loan.caseText} onChange={update}/>
            <MultilineStringInput name={'ReportConfig.installation.caseText'} label={'IP formulka'} value={data.ReportConfig.installation.caseText} onChange={update}/>
        </>
    );

    const parseData = (newData) => ({
        ...newData,
        id: ""
    });

    const parseFromData = (data) => ({...data});

    return (
        <GenericForm label="Systémové nastavenia"
                     baseUrl='/configuration'
                     formContent={formContent}
                     parseData={parseData}
                     parseFromData={parseFromData}
                     id=""
        />
    );
}

export default CompanySetupForm;